var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.199,
    height: 56,
    viewBox: "0 0 44.199 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.433,41.081v1.737h8.6V51.5h8.683V82.756h1.737V41.081Zm10.339,8.683V44.046l5.719,5.719h-5.719ZM280,42.818h5.719v5.718Z",
    transform: "translate(-243.255 -36.325)",
    fill: "#55aced"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.558,168.612h1.722v1.737h-1.722Z",
    transform: "translate(-216.839 -149.091)",
    fill: "#55aced"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.495,168.612h12.149v1.737H268.495Z",
    transform: "translate(-243.31 -149.091)",
    fill: "#55aced"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.558,213.55H220.7v1.737H208.558Z",
    transform: "translate(-190.313 -188.826)",
    fill: "#55aced"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M328.433,213.55h5.21v1.737h-5.21Z",
    transform: "translate(-296.309 -188.826)",
    fill: "#55aced"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.433,258.487h20.84v1.737h-20.84Z",
    transform: "translate(-176.939 -228.561)",
    fill: "#55aced"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.558,303.55h15.615v1.737H238.558Z",
    transform: "translate(-216.839 -268.406)",
    fill: "#55aced"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.558,348.487H171.12v1.737H148.558Z",
    transform: "translate(-137.259 -308.141)",
    fill: "#55aced"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M358.433,348.487h1.737v1.737h-1.737Z",
    transform: "translate(-322.836 -308.141)",
    fill: "#55aced"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.434,393.55H240.8v1.737H223.434Z",
    transform: "translate(-203.466 -347.987)",
    fill: "#55aced"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.427,51.638H58.856V41.209l7.955-29.687,1.9.509L65.686,23.324l1.677.45L70.839,10.8l-3.578-.959.9-3.352h6.246V4.756H68.624l.857-3.2L63.666,0,62.391,4.756H57.12V24.429L50.964,47.4l.813,8.6,5-7.039.341-1.271v5.684H95.163V48.161H93.427ZM64.894,2.127l2.46.659L65.583,9.395l-2.46-.659ZM58.856,6.493h3.07l-3.07,11.455ZM55.183,48.21l-2.116,2.978-.344-3.637,9.951-37.138,2.46.659Z",
    transform: "translate(-50.964 0)",
    fill: "#55aced"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourni);
export default __webpack_public_path__ + "static/media/fourni.09b21147745ad87d79733e4f4c09eb3c.svg";
export { ForwardRef as ReactComponent };